<div class="form-floating">
  <select
    *ngIf="options?.length > 0 && options[0] != null"
    id="select-region"
    class="form-select"
    name="Region"
    [class.invalid]="!control?.valid && control?.touched"
    (change)="writeValue($event.target.value)"
  >
    <option value="" selected disabled hidden>
      {{ 'region.options.none.selected' | translate: { fgbdefault: '--Select--' } }}
    </option>
    <option *ngFor="let region of options" value="{{ region.RegionName }}" [selected]="region.RegionName === innerValue">
      {{ region.DisplayName }}
    </option>
  </select>

  <input
    *ngIf="(options?.length > 0 && options[0] === null) || options === undefined"
    id="select-region"
    class="form-control"
    name="Region"
    [class.invalid]="!control?.valid && control?.touched"
    type="text"
    [value]="innerValue"
    (input)="writeValue($event.target.value)"
  />
  <label for="select-region" *ngIf="label">{{ label }}</label>
</div>
